import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
const PORTFOLIO_ITEMS = [{
  id: 1,
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/qD7qj5CyaYYhrPEdxuioqQ/IMG_5491.mp4',
  title: 'Live Mixology',
  span: 'col-span-1 md:col-span-2 row-span-2',
  aspect: 'aspect-[9/16] md:aspect-auto md:h-[600px]'
}, {
  id: 2,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/qnxDRMgijBWbxj7cXreA3W/Image_(44).jpg',
  title: 'Signature Cocktails',
  span: 'col-span-1',
  aspect: 'aspect-square'
}, {
  id: 3,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/tZqxHhjGFiEKgmATuVtyW8/image.png',
  title: 'Gourmet Presentation',
  span: 'col-span-1',
  aspect: 'aspect-square'
}, {
  id: 4,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/eCX4GJXKumY8ZVJpSxMTyP/Image_(52).jpg',
  title: 'Event Catering',
  span: 'col-span-1 md:col-span-2',
  aspect: 'aspect-[2/1]'
}, {
  id: 5,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/9n2MBPhPvSzV7AXFPRvRSS/image.png',
  title: 'Premium Ingredients',
  span: 'col-span-1',
  aspect: 'aspect-[4/5]'
}, {
  id: 6,
  type: 'image',
  src: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&q=80&w=800',
  title: 'Crafted Perfection',
  span: 'col-span-1',
  aspect: 'aspect-[4/5]'
}, {
  id: 7,
  type: 'image',
  src: 'https://images.unsplash.com/photo-1536935338788-846bb9981813?auto=format&fit=crop&q=80&w=800',
  title: 'Exquisite Bites',
  span: 'col-span-1',
  aspect: 'aspect-square'
}, {
  id: 8,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/3rQeNX4y13rPu7dn8mtDSF/IMG_3430.jpg',
  title: 'Whimsical Presentations',
  span: 'col-span-1',
  aspect: 'aspect-[3/4]'
}, {
  id: 9,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/4M3263wgrEVgKxNcCRp2NW/image.png',
  title: 'Signature Towers',
  span: 'col-span-1 md:col-span-2',
  aspect: 'aspect-square md:aspect-auto md:h-[600px]'
}, {
  id: 10,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/ntShQdakv6KbGyf9Jx4jwG/image.png',
  title: 'Fresh & Vibrant',
  span: 'col-span-1',
  aspect: 'aspect-[3/4]'
}, {
  id: 11,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/g1mZt8srGufve3JxuHBjNY/IMG_3431.jpg',
  title: 'Tropical Vibes',
  span: 'col-span-1',
  aspect: 'aspect-square'
}, {
  id: 12,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/pzrSmnydTYfjAgK6x3SWvg/IMG_3433.jpg',
  title: 'Celebration Setup',
  span: 'col-span-1 md:col-span-2',
  aspect: 'aspect-[4/3]'
}, {
  id: 13,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/1Vi6VKqaGZnn5B4hTQYfTY/IMG_3434.jpg',
  title: 'Signature Cocktails',
  span: 'col-span-1',
  aspect: 'aspect-square'
}, {
  id: 14,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/a2yZ2UPtx7zNGZ6EH4SMan/IMG_3435.jpg',
  title: 'Vibrant Sips',
  span: 'col-span-1',
  aspect: 'aspect-square'
}, {
  id: 15,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/o6aFiVta8X5c4a6U4YaPV4/IMG_3436.jpg',
  title: 'Premium Mixology',
  span: 'col-span-1',
  aspect: 'aspect-square'
}, {
  id: 16,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/hC8ZUCZ3MyaqW3FzCYPDxH/IMG_3437.jpg',
  title: 'Bespoke Experience',
  span: 'col-span-1 md:col-span-2',
  aspect: 'aspect-[16/9]'
}];
export function SeeOurWorks() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-black selection:bg-[#992f74] selection:text-white pt-20" data-id="element-431">
      <Header data-id="element-432" />

      <main className="pb-20" data-id="element-433">
        {/* Header Section */}
        <section className="relative py-20 px-6 text-center" data-id="element-434">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-4xl mx-auto space-y-6" data-id="element-435">
            <h1 className="font-montserrat text-5xl md:text-7xl font-black italic tracking-wide text-white uppercase drop-shadow-lg" data-id="element-436">
              Our <span className="text-[#992f74]" data-id="element-437">Works</span>
            </h1>
            <p className="text-white/80 text-lg md:text-xl font-light max-w-2xl mx-auto leading-relaxed" data-id="element-438">
              A visual journey through our finest moments. Explore our expertly
              crafted cocktails, exquisite gourmet bites, and unforgettable
              event experiences.
            </p>
          </motion.div>
        </section>

        {/* Portfolio Grid */}
        <section className="px-6 md:px-12 max-w-[1400px] mx-auto" data-id="element-439">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 auto-rows-auto" data-id="element-440">
            {PORTFOLIO_ITEMS.map((item, index) => <motion.div key={item.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className={`group flex flex-col ${item.span}`} data-id="element-441">
                <div className={`relative overflow-hidden rounded-xl bg-[#111] border border-white/10 ${item.aspect}`} data-id="element-442">
                  {item.type === 'video' ? <video src={item.src} autoPlay loop muted playsInline className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-443" /> : <img src={item.src} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-444" />}
                </div>

                <div className="mt-4 mb-6" data-id="element-445">
                  <h3 className="font-montserrat text-xl md:text-2xl font-bold italic text-white tracking-wide" data-id="element-446">
                    {item.title}
                  </h3>
                  <div className="w-12 h-1 bg-[#992f74] mt-3" data-id="element-447" />
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 px-6 text-center" data-id="element-448">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl mx-auto space-y-8" data-id="element-449">
            <h2 className="font-montserrat text-3xl md:text-4xl text-white italic" data-id="element-450">
              Ready to create your own unforgettable moments?
            </h2>
            <motion.a href="/book" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-[#992f74] text-white px-10 py-4 text-sm font-bold tracking-widest uppercase hover:bg-white hover:text-[#992f74] transition-colors duration-300 shadow-xl" data-id="element-451">
              Book Your Experience
            </motion.a>
          </motion.div>
        </section>
      </main>

      <Footer data-id="element-452" />
    </motion.div>;
}